// extracted by mini-css-extract-plugin
export default {"-large":"tQLCl2VTOGmLjwGPhF_3","aiBGLight":"F1rGc_90Nv1QWR_LHFxU","aiText":"lyRnJ2dV82p5XhV2oa9I","pulsatingDotForCopyStyles":"d3oTEUyuBBNQTqaH4uBY"};